import {
  resolveWorkspaceBaseBrandkitId,
  servesPages,
} from "@citychallenge/common";
import React, { ReactNode } from "react";

import { ThemeProvider } from "./theme-context";
import { WEB_CONFIG } from "./web-config";

interface DivisionAwareThemeProviderProps {
  children: ReactNode;
}

export const DivisionAwareThemeProvider: React.FC<
  DivisionAwareThemeProviderProps
> = ({ children }) => {
  // For map based and non-learning divisions prefer dark theme
  // It looks better with those modes
  const fallback =
    WEB_CONFIG.DIVISION_INFO?.mapBased ||
    (!WEB_CONFIG.DIVISION_INFO?.articlesEnabled &&
      !WEB_CONFIG.DIVISION_INFO?.eventsEnabled &&
      !WEB_CONFIG.DIVISION_INFO?.webinarsEnabled)
      ? "dark"
      : "auto";

  // Projects with pages apply their base brandkit (org default, or the
  // project's own override) as the light body theme, matching the SSR-rendered
  // `data-theme` so hydration doesn't reset the chrome to plain light.
  const isPages = servesPages(WEB_CONFIG.DIVISION_INFO);
  const lightTheme = resolveWorkspaceBaseBrandkitId(WEB_CONFIG.DIVISION_INFO);

  return (
    <ThemeProvider
      preferredTheme={WEB_CONFIG.DIVISION_INFO?.preferredColorTheme || fallback}
      lightTheme={lightTheme}
      // The pages runtime has no dark mode: lock it to light / the default
      // brandkit. Classic projects keep light/dark.
      lockLight={isPages}
    >
      {children}
    </ThemeProvider>
  );
};
